// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-start-tournament__container {
    background: var( --white-color );
    width: 100%;
    padding: 36px 0 var(--space) 0;
    border-radius: calc( var( --space ) - var(--space-eighth));
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    height: 100%;
    margin-bottom: var(--space);
}

.tournament-start-tournament__stepper {
    margin-bottom: calc( var( --space-x3 ) + var( --space-half ) + var( --space-eighth));
    padding: 0 212px;
}

.step-point__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.step-point {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.step-point .point {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var( --new-gray-disabled-color );
    z-index: 2;
}

.step-line__container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.step-line__container .step-line {
    border-bottom: 2px solid var( --new-gray-disabled-color );
    height: 0;
    width: 100%;
    position: relative;
    top: -12px;
}

.step-line__container .step-line:first-of-type {
    margin-left: var( --space-x3 );
}

.step-line__container .step-line:last-of-type {
    margin-right: var( --space-x3 );
}

.step-line.step-line-completed {
    border-bottom: 2px solid var( --new-green-color );
}

.baloa-username.step-point-label-completed {
    color: var( --new-green-color );
}

.point.step-point-completed {
    background: var( --new-green-color );
}

.tournament-start-tournament__header {
    display: flex;
    align-items: center;
    margin: var( --space-x2 ) 0;
}

.tournament-start-tournament__header .icon-arrow-left {
    font-size: calc( var( --space-and-half ) - var( --space-eighth));
    margin-right: calc( var( --space ) + var( --space-quarter ) );
    cursor: pointer;
}

.tournament-start-tournament__header .baloa-headline-3 {
    color: var( --primary-very-dark-color );
}

.tournament-start-tournament__form__actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: var(--space-x2);
}

.tournament-start-tournament__form__actions .secondary-button {
    margin-right: var( --space );
    border: none;
}

.tournament-start-tournament__enrolled-teams span {
    color: var(--white-color);
    padding: 5px;
    font-size: 30px;
    border-radius: 50%;
}

.tournament-start-tournament__enrolled-teams__container {
    display: flex;
    align-items: center;
    margin-bottom: var( --space-and-half );
}

.tournament-start-tournament__enrolled-teams__container img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.tournament-start-tournament__enrolled-teams {
    width: 50%;
    margin: 0 auto;
}

.tournament-start-tournament__enrolled-teams .baloa-normal-medium {
    color: var( --basic-gray-color );
    text-align: center;
    padding-bottom: var( --space );
    margin-bottom: var( --space-and-half );
    border-bottom: 1px solid var( --new-input-background-color );
}

.tournament-start-tournament__btns-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.tournament-start-tournament__btns-container .secondary-button {
    margin-right: var( --space );
}

.tournament-start-tournament__actions {
    margin: 0 var( --space );
}

.tournament-start-tournament__container .tournament-phases {
    margin: 0 auto;
    padding: 0 var( --space-x3 );
}

.tournament-start-tournament__calendar-container {
    margin: var( --space-x2 );
}

.tournament-start-tournament__team-info {
    margin-left: var( --space-half );
}

.tournament-start-tournament__team-info div:first-of-type {
    margin-bottom: var( --space-eighth );
    color: var( --primary-dark-color );
}

.tournament-start-tournament__team-info div:last-of-type {
    margin-top: var( --space-eighth );
    color: var( --primary-dark-color );
    font-weight: var( --font-regular );
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-start-tournament/TournamentStartTournamentComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,WAAW;IACX,8BAA8B;IAC9B,0DAA0D;IAC1D,iDAAiD;IACjD,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,oFAAoF;IACpF,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,yDAAyD;IACzD,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gEAAgE;IAChE,6DAA6D;IAC7D,eAAe;AACnB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,8BAA8B;IAC9B,sCAAsC;IACtC,4DAA4D;AAChE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,kCAAkC;AACtC","sourcesContent":[".tournament-start-tournament__container {\n    background: var( --white-color );\n    width: 100%;\n    padding: 36px 0 var(--space) 0;\n    border-radius: calc( var( --space ) - var(--space-eighth));\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    height: 100%;\n    margin-bottom: var(--space);\n}\n\n.tournament-start-tournament__stepper {\n    margin-bottom: calc( var( --space-x3 ) + var( --space-half ) + var( --space-eighth));\n    padding: 0 212px;\n}\n\n.step-point__container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.step-point {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.step-point .point {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: var( --new-gray-disabled-color );\n    z-index: 2;\n}\n\n.step-line__container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n}\n\n.step-line__container .step-line {\n    border-bottom: 2px solid var( --new-gray-disabled-color );\n    height: 0;\n    width: 100%;\n    position: relative;\n    top: -12px;\n}\n\n.step-line__container .step-line:first-of-type {\n    margin-left: var( --space-x3 );\n}\n\n.step-line__container .step-line:last-of-type {\n    margin-right: var( --space-x3 );\n}\n\n.step-line.step-line-completed {\n    border-bottom: 2px solid var( --new-green-color );\n}\n\n.baloa-username.step-point-label-completed {\n    color: var( --new-green-color );\n}\n\n.point.step-point-completed {\n    background: var( --new-green-color );\n}\n\n.tournament-start-tournament__header {\n    display: flex;\n    align-items: center;\n    margin: var( --space-x2 ) 0;\n}\n\n.tournament-start-tournament__header .icon-arrow-left {\n    font-size: calc( var( --space-and-half ) - var( --space-eighth));\n    margin-right: calc( var( --space ) + var( --space-quarter ) );\n    cursor: pointer;\n}\n\n.tournament-start-tournament__header .baloa-headline-3 {\n    color: var( --primary-very-dark-color );\n}\n\n.tournament-start-tournament__form__actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: var(--space-x2);\n}\n\n.tournament-start-tournament__form__actions .secondary-button {\n    margin-right: var( --space );\n    border: none;\n}\n\n.tournament-start-tournament__enrolled-teams span {\n    color: var(--white-color);\n    padding: 5px;\n    font-size: 30px;\n    border-radius: 50%;\n}\n\n.tournament-start-tournament__enrolled-teams__container {\n    display: flex;\n    align-items: center;\n    margin-bottom: var( --space-and-half );\n}\n\n.tournament-start-tournament__enrolled-teams__container img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.tournament-start-tournament__enrolled-teams {\n    width: 50%;\n    margin: 0 auto;\n}\n\n.tournament-start-tournament__enrolled-teams .baloa-normal-medium {\n    color: var( --basic-gray-color );\n    text-align: center;\n    padding-bottom: var( --space );\n    margin-bottom: var( --space-and-half );\n    border-bottom: 1px solid var( --new-input-background-color );\n}\n\n.tournament-start-tournament__btns-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.tournament-start-tournament__btns-container .secondary-button {\n    margin-right: var( --space );\n}\n\n.tournament-start-tournament__actions {\n    margin: 0 var( --space );\n}\n\n.tournament-start-tournament__container .tournament-phases {\n    margin: 0 auto;\n    padding: 0 var( --space-x3 );\n}\n\n.tournament-start-tournament__calendar-container {\n    margin: var( --space-x2 );\n}\n\n.tournament-start-tournament__team-info {\n    margin-left: var( --space-half );\n}\n\n.tournament-start-tournament__team-info div:first-of-type {\n    margin-bottom: var( --space-eighth );\n    color: var( --primary-dark-color );\n}\n\n.tournament-start-tournament__team-info div:last-of-type {\n    margin-top: var( --space-eighth );\n    color: var( --primary-dark-color );\n    font-weight: var( --font-regular );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
